import React from 'react'
import { Link } from 'react-router-dom'
import {AiOutlineHome,AiOutlineUser } from "react-icons/ai";
import { FaLaptopCode } from "react-icons/fa";
import { MdContactMail } from "react-icons/md";

const Navigation = () => {
  return (
    <div>
        <div className="btm-nav bg-neutral  w-96  items-center md:my-8  m-auto fixed z-40  rounded h-16 md:h-16 lg:h-10">
        <Link to='/'><AiOutlineHome className='text-2xl text-white hover:scale-110 duration-500 ease-in-out '></AiOutlineHome></Link>
        <Link to='/about'><AiOutlineUser className='text-2xl text-white hover:scale-110 duration-500 ease-in-out'></AiOutlineUser></Link>
        <Link to='/project'>< FaLaptopCode  className='text-2xl text-white hover:scale-110 duration-500 ease-in-out'></ FaLaptopCode ></Link>
        <Link to='/contact'><MdContactMail MdContactMail className='text-2xl text-white hover:scale-110 duration-500 ease-in-out'></MdContactMail ></Link>
</div>
    </div>
  )
}

export default Navigation